import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MetalRatesBar } from "@/components/MetalRatesBar";

export const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <MetalRatesBar />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
